// extracted by mini-css-extract-plugin
export default {"brandPromo":"WF-z","carousel":"XF-z"};